import { render } from "./CustomCategoryListView.vue?vue&type=template&id=30a62c46&scoped=true&ts=true"
import script from "./CustomCategoryListView.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryListView.vue?vue&type=script&lang=ts"

import "./CustomCategoryListView.vue?vue&type=style&index=0&id=30a62c46&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a62c46"]])

export default __exports__